unit uDocAsigna;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, WEBLib.DB, WEBLib.CDS, WEBLib.REST,
  Vcl.Controls, Vcl.Grids, WEBLib.DBCtrls, WEBLib.JSON,
  WEBLib.StdCtrls, System.Variants, Variants,
  WEBLib.ExtCtrls, Vcl.Imaging.jpeg,
  WEBLib.ComCtrls, WEBLib.Buttons, Vcl.StdCtrls, Vcl.Graphics,
  Vcl.Imaging.pngimage, System.DateUtils;

type
  TFDocAsigna = class(TForm)
    WebPanel1: TPanel;
    WebLabel1: TLabel;
    WebComboBox2: TComboBox;
    WebLabel2: TLabel;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton1: TSpeedButton;
    WebPanel2: TPanel;
    WebDBEdit1: TDBEdit;
    WebLabel3: TLabel;
    WebDBEdit2: TDBEdit;
    WebLabel4: TLabel;
    WebDBEdit3: TDBEdit;
    WebDBEdit4: TDBEdit;
    WebLabel5: TLabel;
    WebDBEdit5: TDBEdit;
    WebLabel6: TLabel;
    WebDBEdit6: TDBEdit;
    WebDBEdit7: TDBEdit;
    WebDBEdit8: TDBEdit;
    WebDBEdit9: TDBEdit;
    WebDBEdit10: TDBEdit;
    WebDBEdit11: TDBEdit;
    WebDBEdit12: TDBEdit;
    WebDBEdit13: TDBEdit;
    WebDBEdit14: TDBEdit;
    WebDBEdit15: TDBEdit;
    WebDBGrid1: TDBGrid;
    WebSpeedButton3: TSpeedButton;
    CEntrenaPuestos: TClientConnection;
    TEntrenaPuestos: TClientDataSet;
    DsEntrenaPuestos: TDataSource;
    CPuestos: TClientConnection;
    TPuestos: TClientDataSet;
    DsPuestos: TDataSource;
    WebEdit1: TEdit;
    WebPanel3: TPanel;
    WebLabel13: TLabel;
    WebDBGrid2: TDBGrid;
    WebEdit2: TEdit;
    WebSpeedButton6: TSpeedButton;
    WebSpeedButton5: TSpeedButton;
    WebEdit3: TEdit;
    WebSpeedButton4: TSpeedButton;
    WebSpeedButton7: TSpeedButton;
    WebHttpRequest1: THttpRequest;
    CEntrenaDoc: TClientConnection;
    TEntrenaDoc: TClientDataSet;
    DsEntrenaDoc: TDataSource;
    WebPanel4: TPanel;
    WebLabel7: TLabel;
    WebDBGrid3: TDBGrid;
    WebEdit4: TEdit;
    WebSpeedButton8: TSpeedButton;
    WebSpeedButton9: TSpeedButton;
    WebSpeedButton13: TSpeedButton;
    WebSpeedButton10: TSpeedButton;
    CDeptos: TClientConnection;
    TDeptos: TClientDataSet;
    WebLabel8: TLabel;
    WebEdit5: TEdit;
    WebSpeedButton11: TSpeedButton;
    procedure WebFormCreate(Sender: TObject);
    procedure WebSpeedButton3Click(Sender: TObject);
    procedure CEntrenaPuestosDataReceived(Sender: TObject;
      ARequest: TJSXMLHttpRequestRecord; var AResponse: string);
    procedure WebEdit1Enter(Sender: TObject);
    procedure WebSpeedButton7Click(Sender: TObject);
    procedure WebSpeedButton6Click(Sender: TObject);
    procedure WebSpeedButton5Click(Sender: TObject);
    procedure WebDBGrid2DblClick(Sender: TObject);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure WebSpeedButton4Click(Sender: TObject);
    procedure CPuestosAfterConnect(Sender: TObject);
    procedure CEntrenaDocDataReceived(Sender: TObject;
      ARequest: TJSXMLHttpRequestRecord; var AResponse: string);
    procedure WebSpeedButton8Click(Sender: TObject);
    procedure WebSpeedButton9Click(Sender: TObject);
    procedure WebDBEdit3Enter(Sender: TObject);
    procedure WebDBGrid3DblClick(Sender: TObject);
    procedure WebSpeedButton13Click(Sender: TObject);
    procedure CEntrenaPuestosAfterConnect(Sender: TObject);
    procedure WebSpeedButton10Click(Sender: TObject);
    procedure CDeptosAfterConnect(Sender: TObject);
    procedure WebComboBox2Change(Sender: TObject);
    procedure WebSpeedButton11Click(Sender: TObject);
  private
    { Private declarations }
    procedure DesactivaCaptura;
    procedure ActivaCaptura;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;
type
  TProcedureRef = reference to procedure;

var
  FDocAsigna: TFDocAsigna;
  B1:Integer;
  Metodo:String;


implementation


{$R *.dfm}

procedure SleepAsync(Milliseconds: Integer; AProc: TProcedureRef);
begin
  asm
    setTimeout(function() {
    AProc();
     }, Milliseconds);
  end;
end;

procedure TFDocAsigna.CDeptosAfterConnect(Sender: TObject);
begin
WebComboBox2.Items.Clear;
TDeptos.First;
While not TDeptos.eof do
  begin
  WebComboBox2.Items.Add(TDeptos.FieldByName('Depto').AsString);
  TDeptos.Next;
  end;
end;

procedure TFDocAsigna.CEntrenaDocDataReceived(Sender: TObject;
  ARequest: TJSXMLHttpRequestRecord; var AResponse: string);
begin
WebSpeedButton8.Visible:=True;
end;

procedure TFDocAsigna.CEntrenaPuestosAfterConnect(Sender: TObject);
begin
WebEdit1.Enabled:=True;
WebEdit3.Enabled:=True;
WebSpeedButton11.Visible:=True;
end;

procedure TFDocAsigna.CEntrenaPuestosDataReceived(Sender: TObject;
  ARequest: TJSXMLHttpRequestRecord; var AResponse: string);
begin
WebDBGrid1.Enabled:=True;
end;

procedure TFDocAsigna.CPuestosAfterConnect(Sender: TObject);
begin
WebSpeedButton6.Visible:=True;
end;

procedure TFDocAsigna.WebComboBox2Change(Sender: TObject);
begin
CEntrenaPuestos.Command := httpGET;
  CEntrenaPuestos.URI := 'http://207.244.241.82:9000/EntrenaPuestos?PuestoS=' +
    TPuestos.FieldByName('Clave').AsString+'&Deptos2='+WebComboBox2.Text;
  CEntrenaPuestos.Active := True;
end;

procedure TFDocAsigna.WebDBEdit3Enter(Sender: TObject);
begin
WebPanel4.Visible:=True;
end;

procedure TFDocAsigna.WebDBGrid2DblClick(Sender: TObject);
begin
  WebEdit1.Text := TPuestos.FieldByName('Clave').AsString;
  WebEdit3.Text := TPuestos.FieldByName('Puesto').AsString;
  WebPanel3.Visible := False;
  CEntrenaPuestos.Command := httpGET;
  CEntrenaPuestos.URI := 'http://207.244.241.82:9000/EntrenaPuestos?PuestoS=' +
    TPuestos.FieldByName('Clave').AsString;
  CEntrenaPuestos.Active := True;
  CDeptos.Command := httpGET;
  CDeptos.URI := 'http://207.244.241.82:9000/EntrenaPuestos?PuestoS=' +
    TPuestos.FieldByName('Clave').AsString+'&Deptos=True';
  CDeptos.Active := True;
  WebDBGrid1.Enabled := False;
  WebSpeedButton1.Visible := True;
  WebSpeedButton2.Visible := True;
  WebSpeedButton10.Visible := True;
  WebSpeedButton13.Visible := True;
  WebEdit1.Enabled := False;
  WebEdit3.Enabled := False;
  WebComboBox2.Visible:=True;
end;

procedure TFDocAsigna.WebDBGrid3DblClick(Sender: TObject);
begin
TEntrenaPuestos.FieldByName('Documento').AsString:=TEntrenaDoc.FieldByName('Codigo').AsString;
TEntrenaPuestos.FieldByName('DocumentoDes').AsString:=TEntrenaDoc.FieldByName('Descripcion').AsString;
TEntrenaPuestos.FieldByName('Revision').AsString:=TEntrenaDoc.FieldByName('Revision').AsString;
WebPanel4.Visible:=False;
end;

procedure TFDocAsigna.WebEdit1Enter(Sender: TObject);
begin
WebPanel3.Visible:=True;
end;

procedure TFDocAsigna.WebFormCreate(Sender: TObject);
begin
//ESTO ES PARA USAR LA NAVEGACION DE LAS FLECHAS se regresa al Form1 o el principal
asm
    window.onpopstate = function(event) {
      pas.uDocAsigna.FDocAsigna.Hide();
    };
end;
CEntrenaPuestos.Command := httpGET;
CEntrenaPuestos.URI := 'http://207.244.241.82:9000/EntrenaPuestos';
CEntrenaPuestos.Active := True;
WebDBGrid1.Enabled:=False;
CPuestos.Command := httpGET;
CPuestos.URI := 'http://207.244.241.82:9000/Puestos';
CPuestos.Active := True;
CEntrenaDoc.Command := httpGET;
CEntrenaDoc.URI := 'http://207.244.241.82:9000/EntrenaDoc';
CEntrenaDoc.Active := True;
WebPanel3.Top:=24;
WebPanel3.Left:=27;
WebPanel3.Visible:=False;
WebPanel4.Top:=24;
WebPanel4.Left:=27;
WebPanel4.Visible:=False;

WebEdit1.Enabled:=False;
WebEdit3.Enabled:=False;
DesactivaCaptura;
end;

procedure TFDocAsigna.WebSpeedButton10Click(Sender: TObject);
var
  Data: TJSONObject;
begin
  Data := TJSONObject.Create;
  try
    Data.AddPair('Registro', TEntrenaPuestos.FieldByName('Registro').AsString);

    WebHttpRequest1.URL := 'http://207.244.241.82:9000/EntrenaPuestos';
    WebHttpRequest1.Headers.Clear;
    WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
    WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
    WebHttpRequest1.Command := httpDELETE;
    WebHttpRequest1.PostData := Data.ToJSON;

    WebHttpRequest1.Execute;

  finally
    Data.Free;
  end;
  DesactivaCaptura;
  SleepAsync(300,
    procedure
    begin
      TEntrenaPuestos.Refresh;
    end);
ShowMessage('Registro eliminado!!');
end;

procedure TFDocAsigna.WebSpeedButton11Click(Sender: TObject);
begin
if not TEntrenaPuestos.Locate('Documento', WebEdit5.Text, []) Then
  begin
  ShowMessage('ERROR, DOCUMENTO NO REGISTRADO!!');
  end;
end;

procedure TFDocAsigna.WebSpeedButton13Click(Sender: TObject);
var
  Puesto, URL: string;
begin
Puesto := WebEdit1.Text;

  URL := 'http://207.244.241.82:9000/matrizexcel?Puesto=' + Puesto;

  asm
    window.open(URL, '_blank');
  end;
end;

procedure TFDocAsigna.WebSpeedButton1Click(Sender: TObject);
begin
Metodo:='Agrega';
TEntrenaPuestos.Insert;
TEntrenaPuestos.FieldByName('Puesto').AsString:=TPuestos.FieldByName('Clave').AsString;
TEntrenaPuestos.FieldByName('PuestoDes').AsString:=TPuestos.FieldByName('Puesto').AsString;
ActivaCaptura;
end;

procedure TFDocAsigna.WebSpeedButton2Click(Sender: TObject);
begin
Metodo:='Edita';
TEntrenaPuestos.Edit;
ActivaCaptura;
end;

procedure TFDocAsigna.WebSpeedButton3Click(Sender: TObject);
begin
FDocAsigna.Hide;
end;

procedure TFDocAsigna.WebSpeedButton4Click(Sender: TObject);
begin
//Cancelar
TEntrenaPuestos.Cancel;
DesactivaCaptura;
Metodo:='';
end;

procedure TFDocAsigna.WebSpeedButton5Click(Sender: TObject);
begin
WebPanel3.Visible:=False;
end;

procedure TFDocAsigna.WebSpeedButton6Click(Sender: TObject);
begin
if not TPuestos.Locate('Clave', WebEdit2.Text, []) Then
  begin
  ShowMessage('ERROR, NO EXISTE EL PUESTO: '+WebEdit2.Text);
  end;
end;

procedure TFDocAsigna.WebSpeedButton7Click(Sender: TObject);
var
  Data: TJSONObject;
begin
  TEntrenaPuestos.Post;
  if Metodo = 'Agrega' then
  begin

    // Insertar post
    Data := TJSONObject.Create;
    try
      //Data.AddPair('Registro', TEntrenaPuestos.FieldByName('Registro').AsString);
      Data.AddPair('Puesto', TEntrenaPuestos.FieldByName('Puesto').AsString);
      Data.AddPair('PuestoDes', TEntrenaPuestos.FieldByName('PuestoDes').AsString);
      Data.AddPair('Documento', TEntrenaPuestos.FieldByName('Documento').AsString);
      Data.AddPair('DocumentoDes', TEntrenaPuestos.FieldByName('DocumentoDes').AsString);
      Data.AddPair('Revision', TEntrenaPuestos.FieldByName('Revision').AsString);
      Data.AddPair('Depto1', TEntrenaPuestos.FieldByName('Depto1').AsString);
      Data.AddPair('Depto2', TEntrenaPuestos.FieldByName('Depto2').AsString);
      Data.AddPair('Depto3', TEntrenaPuestos.FieldByName('Depto3').AsString);
      Data.AddPair('Depto4', TEntrenaPuestos.FieldByName('Depto4').AsString);
      Data.AddPair('Depto5', TEntrenaPuestos.FieldByName('Depto5').AsString);
      Data.AddPair('Depto6', TEntrenaPuestos.FieldByName('Depto6').AsString);
      Data.AddPair('Depto7', TEntrenaPuestos.FieldByName('Depto7').AsString);
      Data.AddPair('Depto8', TEntrenaPuestos.FieldByName('Depto8').AsString);
      Data.AddPair('Depto9', TEntrenaPuestos.FieldByName('Depto9').AsString);
      Data.AddPair('Depto10', TEntrenaPuestos.FieldByName('Depto10').AsString);

      WebHttpRequest1.URL := 'http://207.244.241.82:9000/EntrenaPuestos';
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
      WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
      WebHttpRequest1.Command := httpPOST;
      WebHttpRequest1.PostData := Data.ToJSON;

      WebHttpRequest1.Execute;

    finally
      Data.Free;
    end;
    DesactivaCaptura;
    SleepAsync(300,
      procedure
      begin
        TEntrenaPuestos.Refresh;
      end);
    Exit
  end;
if Metodo = 'Edita' then
  begin

    // Insertar post
    Data := TJSONObject.Create;
    try
      Data.AddPair('Registro', TEntrenaPuestos.FieldByName('Registro').AsString);
      Data.AddPair('Puesto', TEntrenaPuestos.FieldByName('Puesto').AsString);
      Data.AddPair('PuestoDes', TEntrenaPuestos.FieldByName('PuestoDes').AsString);
      Data.AddPair('Documento', TEntrenaPuestos.FieldByName('Documento').AsString);
      Data.AddPair('DocumentoDes', TEntrenaPuestos.FieldByName('DocumentoDes').AsString);
      Data.AddPair('Revision', TEntrenaPuestos.FieldByName('Revision').AsString);
      Data.AddPair('Depto1', TEntrenaPuestos.FieldByName('Depto1').AsString);
      Data.AddPair('Depto2', TEntrenaPuestos.FieldByName('Depto2').AsString);
      Data.AddPair('Depto3', TEntrenaPuestos.FieldByName('Depto3').AsString);
      Data.AddPair('Depto4', TEntrenaPuestos.FieldByName('Depto4').AsString);
      Data.AddPair('Depto5', TEntrenaPuestos.FieldByName('Depto5').AsString);
      Data.AddPair('Depto6', TEntrenaPuestos.FieldByName('Depto6').AsString);
      Data.AddPair('Depto7', TEntrenaPuestos.FieldByName('Depto7').AsString);
      Data.AddPair('Depto8', TEntrenaPuestos.FieldByName('Depto8').AsString);
      Data.AddPair('Depto9', TEntrenaPuestos.FieldByName('Depto9').AsString);
      Data.AddPair('Depto10', TEntrenaPuestos.FieldByName('Depto10').AsString);

      WebHttpRequest1.URL := 'http://207.244.241.82:9000/EntrenaPuestos';
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
      WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
      WebHttpRequest1.Command := httpPOST;
      WebHttpRequest1.PostData := Data.ToJSON;

      WebHttpRequest1.Execute;

    finally
      Data.Free;
    end;
    DesactivaCaptura;
    SleepAsync(300,
      procedure
      begin
        TEntrenaPuestos.Refresh;
      end);
    Exit
  end;
Metodo:='';
end;

procedure TFDocAsigna.WebSpeedButton8Click(Sender: TObject);
begin
if not TEntrenaDoc.Locate('Codigo', WebEdit4.Text, []) Then
  begin
  ShowMessage('ERROR, NO EXISTE EL ENTRENAMIENTO: '+WebEdit2.Text);
  end;
end;

procedure TFDocAsigna.WebSpeedButton9Click(Sender: TObject);
begin
WebPanel4.Visible:=False;
end;

procedure TFDocAsigna.DesactivaCaptura;
begin
WebDBEdit1.Enabled:=False;
WebDBEdit2.Enabled:=False;
WebDBEdit3.Enabled:=False;
WebDBEdit4.Enabled:=False;
WebDBEdit5.Enabled:=False;
WebDBEdit6.Enabled:=False;
WebDBEdit7.Enabled:=False;
WebDBEdit8.Enabled:=False;
WebDBEdit9.Enabled:=False;
WebDBEdit10.Enabled:=False;
WebDBEdit11.Enabled:=False;
WebDBEdit12.Enabled:=False;
WebDBEdit13.Enabled:=False;
WebDBEdit14.Enabled:=False;
WebDBEdit15.Enabled:=False;
WebSpeedButton7.Visible:=False;
WebSpeedButton4.Visible:=False;

WebEdit1.Enabled:=True;
WebEdit3.Enabled:=True;
WebDBGrid1.Enabled:=True;
end;

procedure TFDocAsigna.ActivaCaptura;
begin
WebDBEdit1.Enabled:=True;
WebDBEdit2.Enabled:=True;
WebDBEdit3.Enabled:=True;
WebDBEdit4.Enabled:=True;
WebDBEdit5.Enabled:=True;
WebDBEdit6.Enabled:=True;
WebDBEdit7.Enabled:=True;
WebDBEdit8.Enabled:=True;
WebDBEdit9.Enabled:=True;
WebDBEdit10.Enabled:=True;
WebDBEdit11.Enabled:=True;
WebDBEdit12.Enabled:=True;
WebDBEdit13.Enabled:=True;
WebDBEdit14.Enabled:=True;
WebDBEdit15.Enabled:=True;
WebSpeedButton7.Visible:=True;
WebSpeedButton4.Visible:=True;

WebEdit1.Enabled:=False;
WebEdit3.Enabled:=False;
WebDBGrid1.Enabled:=False;
end;

procedure TFDocAsigna.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel8 := TLabel.Create(Self);
  WebSpeedButton13 := TSpeedButton.Create(Self);
  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebComboBox2 := TComboBox.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebEdit3 := TEdit.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebDBEdit1 := TDBEdit.Create(Self);
  WebDBEdit2 := TDBEdit.Create(Self);
  WebDBEdit3 := TDBEdit.Create(Self);
  WebDBEdit4 := TDBEdit.Create(Self);
  WebDBEdit5 := TDBEdit.Create(Self);
  WebDBEdit6 := TDBEdit.Create(Self);
  WebDBEdit7 := TDBEdit.Create(Self);
  WebDBEdit8 := TDBEdit.Create(Self);
  WebDBEdit9 := TDBEdit.Create(Self);
  WebDBEdit10 := TDBEdit.Create(Self);
  WebDBEdit11 := TDBEdit.Create(Self);
  WebDBEdit12 := TDBEdit.Create(Self);
  WebDBEdit13 := TDBEdit.Create(Self);
  WebDBEdit14 := TDBEdit.Create(Self);
  WebDBEdit15 := TDBEdit.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  WebSpeedButton7 := TSpeedButton.Create(Self);
  WebDBGrid1 := TDBGrid.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebDBGrid2 := TDBGrid.Create(Self);
  WebEdit2 := TEdit.Create(Self);
  WebSpeedButton6 := TSpeedButton.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebDBGrid3 := TDBGrid.Create(Self);
  WebEdit4 := TEdit.Create(Self);
  WebSpeedButton8 := TSpeedButton.Create(Self);
  WebSpeedButton9 := TSpeedButton.Create(Self);
  WebSpeedButton10 := TSpeedButton.Create(Self);
  WebEdit5 := TEdit.Create(Self);
  WebSpeedButton11 := TSpeedButton.Create(Self);
  CEntrenaPuestos := TClientConnection.Create(Self);
  TEntrenaPuestos := TClientDataSet.Create(Self);
  DsEntrenaPuestos := TDataSource.Create(Self);
  CPuestos := TClientConnection.Create(Self);
  TPuestos := TClientDataSet.Create(Self);
  DsPuestos := TDataSource.Create(Self);
  WebHttpRequest1 := THttpRequest.Create(Self);
  CEntrenaDoc := TClientConnection.Create(Self);
  TEntrenaDoc := TClientDataSet.Create(Self);
  DsEntrenaDoc := TDataSource.Create(Self);
  CDeptos := TClientConnection.Create(Self);
  TDeptos := TClientDataSet.Create(Self);

  WebLabel8.BeforeLoadDFMValues;
  WebSpeedButton13.BeforeLoadDFMValues;
  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebComboBox2.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebEdit3.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  WebDBEdit2.BeforeLoadDFMValues;
  WebDBEdit3.BeforeLoadDFMValues;
  WebDBEdit4.BeforeLoadDFMValues;
  WebDBEdit5.BeforeLoadDFMValues;
  WebDBEdit6.BeforeLoadDFMValues;
  WebDBEdit7.BeforeLoadDFMValues;
  WebDBEdit8.BeforeLoadDFMValues;
  WebDBEdit9.BeforeLoadDFMValues;
  WebDBEdit10.BeforeLoadDFMValues;
  WebDBEdit11.BeforeLoadDFMValues;
  WebDBEdit12.BeforeLoadDFMValues;
  WebDBEdit13.BeforeLoadDFMValues;
  WebDBEdit14.BeforeLoadDFMValues;
  WebDBEdit15.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  WebSpeedButton7.BeforeLoadDFMValues;
  WebDBGrid1.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebDBGrid2.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  WebSpeedButton6.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebDBGrid3.BeforeLoadDFMValues;
  WebEdit4.BeforeLoadDFMValues;
  WebSpeedButton8.BeforeLoadDFMValues;
  WebSpeedButton9.BeforeLoadDFMValues;
  WebSpeedButton10.BeforeLoadDFMValues;
  WebEdit5.BeforeLoadDFMValues;
  WebSpeedButton11.BeforeLoadDFMValues;
  CEntrenaPuestos.BeforeLoadDFMValues;
  TEntrenaPuestos.BeforeLoadDFMValues;
  DsEntrenaPuestos.BeforeLoadDFMValues;
  CPuestos.BeforeLoadDFMValues;
  TPuestos.BeforeLoadDFMValues;
  DsPuestos.BeforeLoadDFMValues;
  WebHttpRequest1.BeforeLoadDFMValues;
  CEntrenaDoc.BeforeLoadDFMValues;
  TEntrenaDoc.BeforeLoadDFMValues;
  DsEntrenaDoc.BeforeLoadDFMValues;
  CDeptos.BeforeLoadDFMValues;
  TDeptos.BeforeLoadDFMValues;
  try
    Name := 'FDocAsigna';
    Width := 1676;
    Height := 946;
    Caption := 'Asigna documentos a puestos';
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WebLabel8.SetParentComponent(Self);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 8;
    WebLabel8.Top := 739;
    WebLabel8.Width := 246;
    WebLabel8.Height := 13;
    WebLabel8.Caption := 'Busca documento (C'#243'digo/N'#250'mero del documento):';
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebSpeedButton13.SetParentComponent(Self);
    WebSpeedButton13.Name := 'WebSpeedButton13';
    WebSpeedButton13.Left := 546;
    WebSpeedButton13.Top := 166;
    WebSpeedButton13.Width := 119;
    WebSpeedButton13.Height := 44;
    WebSpeedButton13.Caption := 'Matriz';
    WebSpeedButton13.Color := clNone;
    WebSpeedButton13.Glyph.LoadFromFile('uDocAsigna.WebSpeedButton13.Glyph.png');
    WebSpeedButton13.HeightPercent := 100.000000000000000000;
    WebSpeedButton13.Visible := False;
    WebSpeedButton13.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton13, Self, 'OnClick', 'WebSpeedButton13Click');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 8;
    WebPanel1.Top := 16;
    WebPanel1.Width := 513;
    WebPanel1.Height := 94;
    WebPanel1.HeightPercent := 100.000000000000000000;
    WebPanel1.WidthPercent := 100.000000000000000000;
    WebPanel1.BorderColor := clBlack;
    WebPanel1.BorderStyle := bsSingle;
    WebPanel1.Color := clInfoBk;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 16;
    WebLabel1.Top := 16;
    WebLabel1.Width := 33;
    WebLabel1.Height := 13;
    WebLabel1.Caption := 'Puesto';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 327;
    WebLabel2.Top := 16;
    WebLabel2.Width := 69;
    WebLabel2.Height := 13;
    WebLabel2.Caption := 'Departamento';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.Visible := False;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebComboBox2.SetParentComponent(WebPanel1);
    WebComboBox2.Name := 'WebComboBox2';
    WebComboBox2.Left := 327;
    WebComboBox2.Top := 35;
    WebComboBox2.Width := 145;
    WebComboBox2.Height := 21;
    WebComboBox2.HeightPercent := 100.000000000000000000;
    WebComboBox2.Visible := False;
    WebComboBox2.WidthPercent := 100.000000000000000000;
    SetEvent(WebComboBox2, Self, 'OnChange', 'WebComboBox2Change');
    WebComboBox2.ItemIndex := -1;
    WebEdit1.SetParentComponent(WebPanel1);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 16;
    WebEdit1.Top := 35;
    WebEdit1.Width := 69;
    WebEdit1.Height := 22;
    WebEdit1.ChildOrder := 4;
    WebEdit1.HeightPercent := 100.000000000000000000;
    WebEdit1.WidthPercent := 100.000000000000000000;
    SetEvent(WebEdit1, Self, 'OnEnter', 'WebEdit1Enter');
    WebEdit3.SetParentComponent(WebPanel1);
    WebEdit3.Name := 'WebEdit3';
    WebEdit3.Left := 91;
    WebEdit3.Top := 35;
    WebEdit3.Width := 230;
    WebEdit3.Height := 22;
    WebEdit3.ChildOrder := 4;
    WebEdit3.HeightPercent := 100.000000000000000000;
    WebEdit3.WidthPercent := 100.000000000000000000;
    SetEvent(WebEdit3, Self, 'OnEnter', 'WebEdit1Enter');
    WebSpeedButton2.SetParentComponent(Self);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 546;
    WebSpeedButton2.Top := 66;
    WebSpeedButton2.Width := 119;
    WebSpeedButton2.Height := 44;
    WebSpeedButton2.Caption := 'Editar';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.Glyph.LoadFromFile('uDocAsigna.WebSpeedButton2.Glyph.png');
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.Visible := False;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebSpeedButton1.SetParentComponent(Self);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 546;
    WebSpeedButton1.Top := 16;
    WebSpeedButton1.Width := 119;
    WebSpeedButton1.Height := 44;
    WebSpeedButton1.Caption := 'Agregar';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.Glyph.LoadFromFile('uDocAsigna.WebSpeedButton1.Glyph.png');
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.Visible := False;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebPanel2.SetParentComponent(Self);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 8;
    WebPanel2.Top := 116;
    WebPanel2.Width := 513;
    WebPanel2.Height := 258;
    WebPanel2.HeightPercent := 100.000000000000000000;
    WebPanel2.WidthPercent := 100.000000000000000000;
    WebPanel2.BorderColor := clBlack;
    WebPanel2.BorderStyle := bsSingle;
    WebPanel2.ChildOrder := 3;
    WebPanel2.Color := clInfoBk;
    WebLabel3.SetParentComponent(WebPanel2);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 16;
    WebLabel3.Top := 16;
    WebLabel3.Width := 33;
    WebLabel3.Height := 13;
    WebLabel3.Caption := 'Puesto';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(WebPanel2);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 16;
    WebLabel4.Top := 63;
    WebLabel4.Width := 54;
    WebLabel4.Height := 13;
    WebLabel4.Caption := 'Documento';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel2);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 16;
    WebLabel5.Top := 110;
    WebLabel5.Width := 40;
    WebLabel5.Height := 13;
    WebLabel5.Caption := 'Revisi'#243'n';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel6.SetParentComponent(WebPanel2);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 16;
    WebLabel6.Top := 157;
    WebLabel6.Width := 69;
    WebLabel6.Height := 13;
    WebLabel6.Caption := 'Departamento';
    WebLabel6.HeightPercent := 100.000000000000000000;
    WebLabel6.WidthPercent := 100.000000000000000000;
    WebDBEdit1.SetParentComponent(WebPanel2);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 16;
    WebDBEdit1.Top := 35;
    WebDBEdit1.Width := 73;
    WebDBEdit1.Height := 22;
    WebDBEdit1.HeightPercent := 100.000000000000000000;
    WebDBEdit1.ReadOnly := True;
    WebDBEdit1.Text := 'WebDBEdit1';
    WebDBEdit1.WidthPercent := 100.000000000000000000;
    WebDBEdit1.DataField := 'Puesto';
    WebDBEdit1.DataSource := DsEntrenaPuestos;
    WebDBEdit2.SetParentComponent(WebPanel2);
    WebDBEdit2.Name := 'WebDBEdit2';
    WebDBEdit2.Left := 95;
    WebDBEdit2.Top := 35;
    WebDBEdit2.Width := 226;
    WebDBEdit2.Height := 22;
    WebDBEdit2.ChildOrder := 2;
    WebDBEdit2.HeightPercent := 100.000000000000000000;
    WebDBEdit2.ReadOnly := True;
    WebDBEdit2.Text := 'WebDBEdit1';
    WebDBEdit2.WidthPercent := 100.000000000000000000;
    WebDBEdit2.DataField := 'PuestoDes';
    WebDBEdit2.DataSource := DsEntrenaPuestos;
    WebDBEdit3.SetParentComponent(WebPanel2);
    WebDBEdit3.Name := 'WebDBEdit3';
    WebDBEdit3.Left := 16;
    WebDBEdit3.Top := 82;
    WebDBEdit3.Width := 105;
    WebDBEdit3.Height := 22;
    WebDBEdit3.ChildOrder := 4;
    WebDBEdit3.HeightPercent := 100.000000000000000000;
    WebDBEdit3.ReadOnly := True;
    WebDBEdit3.Text := 'WebDBEdit1';
    WebDBEdit3.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBEdit3, Self, 'OnEnter', 'WebDBEdit3Enter');
    WebDBEdit3.DataField := 'Documento';
    WebDBEdit3.DataSource := DsEntrenaPuestos;
    WebDBEdit4.SetParentComponent(WebPanel2);
    WebDBEdit4.Name := 'WebDBEdit4';
    WebDBEdit4.Left := 127;
    WebDBEdit4.Top := 82;
    WebDBEdit4.Width := 242;
    WebDBEdit4.Height := 22;
    WebDBEdit4.ChildOrder := 4;
    WebDBEdit4.HeightPercent := 100.000000000000000000;
    WebDBEdit4.ReadOnly := True;
    WebDBEdit4.Text := 'WebDBEdit1';
    WebDBEdit4.WidthPercent := 100.000000000000000000;
    WebDBEdit4.DataField := 'DocumentoDes';
    WebDBEdit4.DataSource := DsEntrenaPuestos;
    WebDBEdit5.SetParentComponent(WebPanel2);
    WebDBEdit5.Name := 'WebDBEdit5';
    WebDBEdit5.Left := 16;
    WebDBEdit5.Top := 129;
    WebDBEdit5.Width := 105;
    WebDBEdit5.Height := 22;
    WebDBEdit5.ChildOrder := 4;
    WebDBEdit5.HeightPercent := 100.000000000000000000;
    WebDBEdit5.ReadOnly := True;
    WebDBEdit5.Text := 'WebDBEdit1';
    WebDBEdit5.WidthPercent := 100.000000000000000000;
    WebDBEdit5.DataField := 'Revision';
    WebDBEdit5.DataSource := DsEntrenaPuestos;
    WebDBEdit6.SetParentComponent(WebPanel2);
    WebDBEdit6.Name := 'WebDBEdit6';
    WebDBEdit6.Left := 16;
    WebDBEdit6.Top := 176;
    WebDBEdit6.Width := 54;
    WebDBEdit6.Height := 22;
    WebDBEdit6.ChildOrder := 4;
    WebDBEdit6.HeightPercent := 100.000000000000000000;
    WebDBEdit6.Text := 'WebDBEdit1';
    WebDBEdit6.WidthPercent := 100.000000000000000000;
    WebDBEdit6.DataField := 'Depto1';
    WebDBEdit6.DataSource := DsEntrenaPuestos;
    WebDBEdit7.SetParentComponent(WebPanel2);
    WebDBEdit7.Name := 'WebDBEdit7';
    WebDBEdit7.Left := 76;
    WebDBEdit7.Top := 176;
    WebDBEdit7.Width := 54;
    WebDBEdit7.Height := 22;
    WebDBEdit7.ChildOrder := 4;
    WebDBEdit7.HeightPercent := 100.000000000000000000;
    WebDBEdit7.Text := 'WebDBEdit1';
    WebDBEdit7.WidthPercent := 100.000000000000000000;
    WebDBEdit7.DataField := 'Depto2';
    WebDBEdit7.DataSource := DsEntrenaPuestos;
    WebDBEdit8.SetParentComponent(WebPanel2);
    WebDBEdit8.Name := 'WebDBEdit8';
    WebDBEdit8.Left := 136;
    WebDBEdit8.Top := 176;
    WebDBEdit8.Width := 54;
    WebDBEdit8.Height := 22;
    WebDBEdit8.ChildOrder := 4;
    WebDBEdit8.HeightPercent := 100.000000000000000000;
    WebDBEdit8.Text := 'WebDBEdit1';
    WebDBEdit8.WidthPercent := 100.000000000000000000;
    WebDBEdit8.DataField := 'Depto3';
    WebDBEdit8.DataSource := DsEntrenaPuestos;
    WebDBEdit9.SetParentComponent(WebPanel2);
    WebDBEdit9.Name := 'WebDBEdit9';
    WebDBEdit9.Left := 196;
    WebDBEdit9.Top := 176;
    WebDBEdit9.Width := 54;
    WebDBEdit9.Height := 22;
    WebDBEdit9.ChildOrder := 4;
    WebDBEdit9.HeightPercent := 100.000000000000000000;
    WebDBEdit9.Text := 'WebDBEdit1';
    WebDBEdit9.WidthPercent := 100.000000000000000000;
    WebDBEdit9.DataField := 'Depto4';
    WebDBEdit9.DataSource := DsEntrenaPuestos;
    WebDBEdit10.SetParentComponent(WebPanel2);
    WebDBEdit10.Name := 'WebDBEdit10';
    WebDBEdit10.Left := 256;
    WebDBEdit10.Top := 176;
    WebDBEdit10.Width := 54;
    WebDBEdit10.Height := 22;
    WebDBEdit10.ChildOrder := 4;
    WebDBEdit10.HeightPercent := 100.000000000000000000;
    WebDBEdit10.Text := 'WebDBEdit1';
    WebDBEdit10.WidthPercent := 100.000000000000000000;
    WebDBEdit10.DataField := 'Depto5';
    WebDBEdit10.DataSource := DsEntrenaPuestos;
    WebDBEdit11.SetParentComponent(WebPanel2);
    WebDBEdit11.Name := 'WebDBEdit11';
    WebDBEdit11.Left := 16;
    WebDBEdit11.Top := 204;
    WebDBEdit11.Width := 54;
    WebDBEdit11.Height := 22;
    WebDBEdit11.ChildOrder := 4;
    WebDBEdit11.HeightPercent := 100.000000000000000000;
    WebDBEdit11.Text := 'WebDBEdit1';
    WebDBEdit11.WidthPercent := 100.000000000000000000;
    WebDBEdit11.DataField := 'Depto6';
    WebDBEdit11.DataSource := DsEntrenaPuestos;
    WebDBEdit12.SetParentComponent(WebPanel2);
    WebDBEdit12.Name := 'WebDBEdit12';
    WebDBEdit12.Left := 76;
    WebDBEdit12.Top := 204;
    WebDBEdit12.Width := 54;
    WebDBEdit12.Height := 22;
    WebDBEdit12.ChildOrder := 4;
    WebDBEdit12.HeightPercent := 100.000000000000000000;
    WebDBEdit12.Text := 'WebDBEdit1';
    WebDBEdit12.WidthPercent := 100.000000000000000000;
    WebDBEdit12.DataField := 'Depto7';
    WebDBEdit12.DataSource := DsEntrenaPuestos;
    WebDBEdit13.SetParentComponent(WebPanel2);
    WebDBEdit13.Name := 'WebDBEdit13';
    WebDBEdit13.Left := 136;
    WebDBEdit13.Top := 204;
    WebDBEdit13.Width := 54;
    WebDBEdit13.Height := 22;
    WebDBEdit13.ChildOrder := 4;
    WebDBEdit13.HeightPercent := 100.000000000000000000;
    WebDBEdit13.Text := 'WebDBEdit1';
    WebDBEdit13.WidthPercent := 100.000000000000000000;
    WebDBEdit13.DataField := 'Depto8';
    WebDBEdit13.DataSource := DsEntrenaPuestos;
    WebDBEdit14.SetParentComponent(WebPanel2);
    WebDBEdit14.Name := 'WebDBEdit14';
    WebDBEdit14.Left := 196;
    WebDBEdit14.Top := 204;
    WebDBEdit14.Width := 54;
    WebDBEdit14.Height := 22;
    WebDBEdit14.ChildOrder := 4;
    WebDBEdit14.HeightPercent := 100.000000000000000000;
    WebDBEdit14.Text := 'WebDBEdit1';
    WebDBEdit14.WidthPercent := 100.000000000000000000;
    WebDBEdit14.DataField := 'Depto9';
    WebDBEdit14.DataSource := DsEntrenaPuestos;
    WebDBEdit15.SetParentComponent(WebPanel2);
    WebDBEdit15.Name := 'WebDBEdit15';
    WebDBEdit15.Left := 256;
    WebDBEdit15.Top := 204;
    WebDBEdit15.Width := 54;
    WebDBEdit15.Height := 22;
    WebDBEdit15.ChildOrder := 4;
    WebDBEdit15.HeightPercent := 100.000000000000000000;
    WebDBEdit15.Text := 'WebDBEdit1';
    WebDBEdit15.WidthPercent := 100.000000000000000000;
    WebDBEdit15.DataField := 'Depto10';
    WebDBEdit15.DataSource := DsEntrenaPuestos;
    WebSpeedButton4.SetParentComponent(WebPanel2);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 456;
    WebSpeedButton4.Top := 16;
    WebSpeedButton4.Width := 41;
    WebSpeedButton4.Height := 33;
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.Glyph.LoadFromFile('uDocAsigna.WebPanel2.WebSpeedButton4.Glyph.png');
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.Layout := blGlyphTop;
    WebSpeedButton4.Visible := False;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton4Click');
    WebSpeedButton7.SetParentComponent(WebPanel2);
    WebSpeedButton7.Name := 'WebSpeedButton7';
    WebSpeedButton7.Left := 409;
    WebSpeedButton7.Top := 16;
    WebSpeedButton7.Width := 41;
    WebSpeedButton7.Height := 33;
    WebSpeedButton7.Color := clNone;
    WebSpeedButton7.Glyph.LoadFromFile('uDocAsigna.WebPanel2.WebSpeedButton7.Glyph.png');
    WebSpeedButton7.HeightPercent := 100.000000000000000000;
    WebSpeedButton7.Layout := blGlyphTop;
    WebSpeedButton7.Visible := False;
    WebSpeedButton7.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton7, Self, 'OnClick', 'WebSpeedButton7Click');
    WebDBGrid1.SetParentComponent(Self);
    WebDBGrid1.Name := 'WebDBGrid1';
    WebDBGrid1.Left := 8;
    WebDBGrid1.Top := 380;
    WebDBGrid1.Width := 817;
    WebDBGrid1.Height := 354;
    WebDBGrid1.Columns.Clear;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'PuestoDes';
      Title := 'Puesto';
      Width := 150;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Documento';
      Title := 'N'#250'mero de documento';
      Width := 150;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'DocumentoDes';
      Title := 'Descripci'#243'n';
      Width := 350;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Revision';
      Title := 'Rev.';
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'DeptosTotal';
      Title := 'Deptos';
      Width := 200;
    end;
    WebDBGrid1.DataSource := DsEntrenaPuestos;
    WebDBGrid1.FixedCols := 1;
    WebDBGrid1.TabOrder := 4;
    WebDBGrid1.HeightPercent := 100.000000000000000000;
    WebDBGrid1.WidthPercent := 100.000000000000000000;
    WebDBGrid1.ColWidths[0] := 24;
    WebDBGrid1.ColWidths[1] := 150;
    WebDBGrid1.ColWidths[2] := 150;
    WebDBGrid1.ColWidths[3] := 350;
    WebDBGrid1.ColWidths[4] := 64;
    WebDBGrid1.ColWidths[5] := 200;
    WebSpeedButton3.SetParentComponent(Self);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 876;
    WebSpeedButton3.Top := 8;
    WebSpeedButton3.Width := 81;
    WebSpeedButton3.Height := 44;
    WebSpeedButton3.Caption := 'Salir';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.Glyph.LoadFromFile('uDocAsigna.WebSpeedButton3.Glyph.png');
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    WebPanel3.SetParentComponent(Self);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 845;
    WebPanel3.Top := 87;
    WebPanel3.Width := 658;
    WebPanel3.Height := 326;
    WebPanel3.HeightPercent := 100.000000000000000000;
    WebPanel3.WidthPercent := 100.000000000000000000;
    WebPanel3.BorderColor := clSilver;
    WebPanel3.BorderStyle := bsSingle;
    WebPanel3.ChildOrder := 8;
    WebPanel3.Color := 16764573;
    WebPanel3.Visible := False;
    WebLabel13.SetParentComponent(WebPanel3);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 30;
    WebLabel13.Top := 27;
    WebLabel13.Width := 196;
    WebLabel13.Height := 13;
    WebLabel13.Caption := 'Busca puesto (C'#243'digo/Clave del puesto):';
    WebLabel13.HeightPercent := 100.000000000000000000;
    WebLabel13.WidthPercent := 100.000000000000000000;
    WebDBGrid2.SetParentComponent(WebPanel3);
    WebDBGrid2.Name := 'WebDBGrid2';
    WebDBGrid2.Left := 30;
    WebDBGrid2.Top := 79;
    WebDBGrid2.Width := 595;
    WebDBGrid2.Height := 214;
    WebDBGrid2.Columns.Clear;
    with WebDBGrid2.Columns.Add do
    begin
      DataField := 'Clave';
      Title := 'Puesto';
      Width := 150;
    end;
    with WebDBGrid2.Columns.Add do
    begin
      DataField := 'Puesto';
      Title := 'Descripci'#243'n';
      Width := 350;
    end;
    WebDBGrid2.DataSource := DsPuestos;
    WebDBGrid2.FixedCols := 1;
    WebDBGrid2.TabOrder := 0;
    WebDBGrid2.HeightPercent := 100.000000000000000000;
    WebDBGrid2.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBGrid2, Self, 'OnDblClick', 'WebDBGrid2DblClick');
    WebDBGrid2.ColWidths[0] := 24;
    WebDBGrid2.ColWidths[1] := 150;
    WebDBGrid2.ColWidths[2] := 350;
    WebEdit2.SetParentComponent(WebPanel3);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 30;
    WebEdit2.Top := 46;
    WebEdit2.Width := 196;
    WebEdit2.Height := 22;
    WebEdit2.ChildOrder := 4;
    WebEdit2.HeightPercent := 100.000000000000000000;
    WebEdit2.WidthPercent := 100.000000000000000000;
    WebSpeedButton6.SetParentComponent(WebPanel3);
    WebSpeedButton6.Name := 'WebSpeedButton6';
    WebSpeedButton6.Left := 242;
    WebSpeedButton6.Top := 41;
    WebSpeedButton6.Width := 100;
    WebSpeedButton6.Height := 24;
    WebSpeedButton6.Caption := 'Buscar';
    WebSpeedButton6.Color := clNone;
    WebSpeedButton6.Glyph.LoadFromFile('uDocAsigna.WebPanel3.WebSpeedButton6.Glyph.png');
    WebSpeedButton6.HeightPercent := 100.000000000000000000;
    WebSpeedButton6.Visible := False;
    WebSpeedButton6.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton6, Self, 'OnClick', 'WebSpeedButton6Click');
    WebSpeedButton5.SetParentComponent(WebPanel3);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 360;
    WebSpeedButton5.Top := 41;
    WebSpeedButton5.Width := 100;
    WebSpeedButton5.Height := 24;
    WebSpeedButton5.Caption := 'Cancelar';
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.Glyph.LoadFromFile('uDocAsigna.WebPanel3.WebSpeedButton5.Glyph.png');
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    WebPanel4.SetParentComponent(Self);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 845;
    WebPanel4.Top := 435;
    WebPanel4.Width := 658;
    WebPanel4.Height := 326;
    WebPanel4.HeightPercent := 100.000000000000000000;
    WebPanel4.WidthPercent := 100.000000000000000000;
    WebPanel4.BorderColor := clSilver;
    WebPanel4.BorderStyle := bsSingle;
    WebPanel4.ChildOrder := 8;
    WebPanel4.Color := 11599792;
    WebPanel4.Visible := False;
    WebLabel7.SetParentComponent(WebPanel4);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 30;
    WebLabel7.Top := 27;
    WebLabel7.Width := 246;
    WebLabel7.Height := 13;
    WebLabel7.Caption := 'Busca documento (C'#243'digo/N'#250'mero del documento):';
    WebLabel7.HeightPercent := 100.000000000000000000;
    WebLabel7.WidthPercent := 100.000000000000000000;
    WebDBGrid3.SetParentComponent(WebPanel4);
    WebDBGrid3.Name := 'WebDBGrid3';
    WebDBGrid3.Left := 30;
    WebDBGrid3.Top := 79;
    WebDBGrid3.Width := 595;
    WebDBGrid3.Height := 214;
    WebDBGrid3.Columns.Clear;
    with WebDBGrid3.Columns.Add do
    begin
      DataField := 'Codigo';
      Title := 'Documento';
      Width := 150;
    end;
    with WebDBGrid3.Columns.Add do
    begin
      DataField := 'Descripcion';
      Title := 'Descripci'#243'n';
      Width := 350;
    end;
    WebDBGrid3.DataSource := DsEntrenaDoc;
    WebDBGrid3.FixedCols := 1;
    WebDBGrid3.TabOrder := 0;
    WebDBGrid3.HeightPercent := 100.000000000000000000;
    WebDBGrid3.WidthPercent := 100.000000000000000000;
    SetEvent(WebDBGrid3, Self, 'OnDblClick', 'WebDBGrid3DblClick');
    WebDBGrid3.ColWidths[0] := 24;
    WebDBGrid3.ColWidths[1] := 150;
    WebDBGrid3.ColWidths[2] := 350;
    WebDBGrid3.RowHeights[0] := 22;
    WebDBGrid3.RowHeights[1] := 22;
    WebDBGrid3.RowHeights[2] := 22;
    WebDBGrid3.RowHeights[3] := 22;
    WebDBGrid3.RowHeights[4] := 22;
    WebEdit4.SetParentComponent(WebPanel4);
    WebEdit4.Name := 'WebEdit4';
    WebEdit4.Left := 30;
    WebEdit4.Top := 46;
    WebEdit4.Width := 196;
    WebEdit4.Height := 22;
    WebEdit4.ChildOrder := 4;
    WebEdit4.HeightPercent := 100.000000000000000000;
    WebEdit4.WidthPercent := 100.000000000000000000;
    WebSpeedButton8.SetParentComponent(WebPanel4);
    WebSpeedButton8.Name := 'WebSpeedButton8';
    WebSpeedButton8.Left := 242;
    WebSpeedButton8.Top := 41;
    WebSpeedButton8.Width := 100;
    WebSpeedButton8.Height := 24;
    WebSpeedButton8.Caption := 'Buscar';
    WebSpeedButton8.Color := clNone;
    WebSpeedButton8.Glyph.LoadFromFile('uDocAsigna.WebPanel4.WebSpeedButton8.Glyph.png');
    WebSpeedButton8.HeightPercent := 100.000000000000000000;
    WebSpeedButton8.Visible := False;
    WebSpeedButton8.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton8, Self, 'OnClick', 'WebSpeedButton8Click');
    WebSpeedButton9.SetParentComponent(WebPanel4);
    WebSpeedButton9.Name := 'WebSpeedButton9';
    WebSpeedButton9.Left := 360;
    WebSpeedButton9.Top := 41;
    WebSpeedButton9.Width := 100;
    WebSpeedButton9.Height := 24;
    WebSpeedButton9.Caption := 'Cancelar';
    WebSpeedButton9.Color := clNone;
    WebSpeedButton9.Glyph.LoadFromFile('uDocAsigna.WebPanel4.WebSpeedButton9.Glyph.png');
    WebSpeedButton9.HeightPercent := 100.000000000000000000;
    WebSpeedButton9.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton9, Self, 'OnClick', 'WebSpeedButton9Click');
    WebSpeedButton10.SetParentComponent(Self);
    WebSpeedButton10.Name := 'WebSpeedButton10';
    WebSpeedButton10.Left := 546;
    WebSpeedButton10.Top := 116;
    WebSpeedButton10.Width := 119;
    WebSpeedButton10.Height := 44;
    WebSpeedButton10.Caption := 'Borrar';
    WebSpeedButton10.Color := clNone;
    WebSpeedButton10.Glyph.LoadFromFile('uDocAsigna.WebSpeedButton10.Glyph.png');
    WebSpeedButton10.HeightPercent := 100.000000000000000000;
    WebSpeedButton10.Visible := False;
    WebSpeedButton10.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton10, Self, 'OnClick', 'WebSpeedButton10Click');
    WebEdit5.SetParentComponent(Self);
    WebEdit5.Name := 'WebEdit5';
    WebEdit5.Left := 8;
    WebEdit5.Top := 758;
    WebEdit5.Width := 196;
    WebEdit5.Height := 22;
    WebEdit5.ChildOrder := 4;
    WebEdit5.HeightPercent := 100.000000000000000000;
    WebEdit5.WidthPercent := 100.000000000000000000;
    WebSpeedButton11.SetParentComponent(Self);
    WebSpeedButton11.Name := 'WebSpeedButton11';
    WebSpeedButton11.Left := 210;
    WebSpeedButton11.Top := 758;
    WebSpeedButton11.Width := 100;
    WebSpeedButton11.Height := 24;
    WebSpeedButton11.Caption := 'Buscar';
    WebSpeedButton11.Color := clNone;
    WebSpeedButton11.Glyph.LoadFromFile('uDocAsigna.WebSpeedButton11.Glyph.png');
    WebSpeedButton11.HeightPercent := 100.000000000000000000;
    WebSpeedButton11.Visible := False;
    WebSpeedButton11.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton11, Self, 'OnClick', 'WebSpeedButton11Click');
    CEntrenaPuestos.SetParentComponent(Self);
    CEntrenaPuestos.Name := 'CEntrenaPuestos';
    CEntrenaPuestos.Active := False;
    CEntrenaPuestos.AfterConnect := CEntrenaPuestosAfterConnect;
    SetEvent(CEntrenaPuestos, Self, 'OnDataReceived', 'CEntrenaPuestosDataReceived');
    CEntrenaPuestos.Left := 568;
    CEntrenaPuestos.Top := 144;
    TEntrenaPuestos.SetParentComponent(Self);
    TEntrenaPuestos.Name := 'TEntrenaPuestos';
    TEntrenaPuestos.Connection := CEntrenaPuestos;
    TEntrenaPuestos.Left := 656;
    TEntrenaPuestos.Top := 144;
    DsEntrenaPuestos.SetParentComponent(Self);
    DsEntrenaPuestos.Name := 'DsEntrenaPuestos';
    DsEntrenaPuestos.DataSet := TEntrenaPuestos;
    DsEntrenaPuestos.Left := 752;
    DsEntrenaPuestos.Top := 144;
    CPuestos.SetParentComponent(Self);
    CPuestos.Name := 'CPuestos';
    CPuestos.Active := False;
    CPuestos.AfterConnect := CPuestosAfterConnect;
    CPuestos.Left := 568;
    CPuestos.Top := 208;
    TPuestos.SetParentComponent(Self);
    TPuestos.Name := 'TPuestos';
    TPuestos.Connection := CPuestos;
    TPuestos.Left := 616;
    TPuestos.Top := 208;
    DsPuestos.SetParentComponent(Self);
    DsPuestos.Name := 'DsPuestos';
    DsPuestos.DataSet := TPuestos;
    DsPuestos.Left := 664;
    DsPuestos.Top := 208;
    WebHttpRequest1.SetParentComponent(Self);
    WebHttpRequest1.Name := 'WebHttpRequest1';
    WebHttpRequest1.Headers.BeginUpdate;
    try
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.Add('Cache-Control=no-cache, no-store, must-revalidate');
    finally
      WebHttpRequest1.Headers.EndUpdate;
    end;
    WebHttpRequest1.Left := 736;
    WebHttpRequest1.Top := 80;
    CEntrenaDoc.SetParentComponent(Self);
    CEntrenaDoc.Name := 'CEntrenaDoc';
    CEntrenaDoc.Active := False;
    SetEvent(CEntrenaDoc, Self, 'OnDataReceived', 'CEntrenaDocDataReceived');
    CEntrenaDoc.Left := 568;
    CEntrenaDoc.Top := 264;
    TEntrenaDoc.SetParentComponent(Self);
    TEntrenaDoc.Name := 'TEntrenaDoc';
    TEntrenaDoc.Connection := CEntrenaDoc;
    TEntrenaDoc.Left := 640;
    TEntrenaDoc.Top := 264;
    DsEntrenaDoc.SetParentComponent(Self);
    DsEntrenaDoc.Name := 'DsEntrenaDoc';
    DsEntrenaDoc.DataSet := TEntrenaDoc;
    DsEntrenaDoc.Left := 712;
    DsEntrenaDoc.Top := 264;
    CDeptos.SetParentComponent(Self);
    CDeptos.Name := 'CDeptos';
    CDeptos.Active := False;
    CDeptos.AfterConnect := CDeptosAfterConnect;
    CDeptos.Left := 560;
    CDeptos.Top := 320;
    TDeptos.SetParentComponent(Self);
    TDeptos.Name := 'TDeptos';
    TDeptos.Connection := CDeptos;
    TDeptos.Left := 632;
    TDeptos.Top := 320;
  finally
    WebLabel8.AfterLoadDFMValues;
    WebSpeedButton13.AfterLoadDFMValues;
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebComboBox2.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebEdit3.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    WebDBEdit2.AfterLoadDFMValues;
    WebDBEdit3.AfterLoadDFMValues;
    WebDBEdit4.AfterLoadDFMValues;
    WebDBEdit5.AfterLoadDFMValues;
    WebDBEdit6.AfterLoadDFMValues;
    WebDBEdit7.AfterLoadDFMValues;
    WebDBEdit8.AfterLoadDFMValues;
    WebDBEdit9.AfterLoadDFMValues;
    WebDBEdit10.AfterLoadDFMValues;
    WebDBEdit11.AfterLoadDFMValues;
    WebDBEdit12.AfterLoadDFMValues;
    WebDBEdit13.AfterLoadDFMValues;
    WebDBEdit14.AfterLoadDFMValues;
    WebDBEdit15.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    WebSpeedButton7.AfterLoadDFMValues;
    WebDBGrid1.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebDBGrid2.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
    WebSpeedButton6.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebDBGrid3.AfterLoadDFMValues;
    WebEdit4.AfterLoadDFMValues;
    WebSpeedButton8.AfterLoadDFMValues;
    WebSpeedButton9.AfterLoadDFMValues;
    WebSpeedButton10.AfterLoadDFMValues;
    WebEdit5.AfterLoadDFMValues;
    WebSpeedButton11.AfterLoadDFMValues;
    CEntrenaPuestos.AfterLoadDFMValues;
    TEntrenaPuestos.AfterLoadDFMValues;
    DsEntrenaPuestos.AfterLoadDFMValues;
    CPuestos.AfterLoadDFMValues;
    TPuestos.AfterLoadDFMValues;
    DsPuestos.AfterLoadDFMValues;
    WebHttpRequest1.AfterLoadDFMValues;
    CEntrenaDoc.AfterLoadDFMValues;
    TEntrenaDoc.AfterLoadDFMValues;
    DsEntrenaDoc.AfterLoadDFMValues;
    CDeptos.AfterLoadDFMValues;
    TDeptos.AfterLoadDFMValues;
  end;
end;

end.
